export default "__VITE_ASSET__BSLo78X6__"